import React, { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { IoCloseSharp, BsImages } from "../../components/utils/icons";
import { useStateContext } from '../../context/ContextProvider';

import { DLabel, Select, DSpinButton } from '../utils/Form';

import { toast } from 'react-toastify';
import { Loader } from '../utils';

import {useParams} from "react-router-dom"
import { BaseUrl, media } from '../../server';

import { getVideo } from '../../redux/actions/videos';
import { getAllVideoCategorys } from '../../redux/actions/videoCategory';
function EditVideo() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();

  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
 
  const {id}=useParams()

  useEffect(() => {
   dispatch(getVideo(id))
   dispatch(getAllVideoCategorys());
  }, [ dispatch ,id]);  
  const { isLoading , videoData} = useSelector(
    (state) => state.Videos
  );
  const { videoCategorys } = useSelector((state) => state.VideoCategory);
  const [titleAr, setTitleAr] = useState( videoData?.titleAr);
  const [titleEn, setTitleEn] = useState(videoData?.titleEn );
  const [categoryId ,setCategoryId]=useState(videoData?.categoryId )
  const [date ,setDate]=useState(videoData?.date)
  const [video ,setVideo]=useState(videoData?.url)
  const [image, setImage] = useState(videoData?.Image);
  const [imageShow, setImageShow] = useState({url:`${media}${videoData?.Image}`});

  useEffect(() => {
    if (videoData) {
      setTitleAr(videoData.titleAr );
      setTitleEn(videoData.titleEn );

      setCategoryId(videoData.categoryId );
  
      setDate(videoData.date);
      setImage(videoData.Image );
      setImageShow({ url: `${media}${videoData.Image}`});
    }
  }, [videoData]);

  const inmageHandle = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
      const imageUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setImageShow(imageUrl);
    }
  };

  const changeImage = (img) => {
    if (img) {
      const tempUrl = { url: URL.createObjectURL(img) }; // كائن مباشر
      setImageShow(tempUrl);
      setImage(img);
    }
  };

  const removeImage = () => {
    setImage();
    setImageShow();
  };

  const UpdateBlog = async (newForm) => {
    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } ,withCredentials: true  };
        const { data } = await axios.put(`${BaseUrl}/videos/${id}`, newForm, config );
        if(data.success){
        // عرض رسالة نجاح
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Video updated successfully!")}</span>);

        // إعادة تعيين الحالات
        setIsSpinner(false);
        }
    } catch (error) {
        // عرض رسالة خطأ
        toast.error(error.response?.data?.message);
        setIsSpinner(false);
    }
};
const handleSubmit = (e) => {
  e.preventDefault();
  setIsSpinner(true);
  const newForm = new FormData();

  // إضافة الصورة فقط إذا كانت موجودة وتم تغييرها
  if (image instanceof File) {
    newForm.append("file", image);
  }

  newForm.append("categoryId", categoryId);
  newForm.append("date", date);
  newForm.append("titleAr", titleAr);
  newForm.append("titleEn", titleEn);
  newForm.append("url", video);


  UpdateBlog(newForm);
};

  return (<>{
    isLoading  ? (<Loader />) :(
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
        <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
          {t("Edit Blog")}
        </h3>
        <form onSubmit={handleSubmit}>
          <br />
          <div>
      
          <DLabel
              labelText="Title (Ar)"
              value={titleAr}
              onChange={(e)=> {setTitleAr(e.target.value)}}
           
              type="text"
              name="titleAr"
            />
             <DLabel
              labelText="Title (En)"
              value={titleEn}
              onChange={(e)=> {setTitleEn(e.target.value)}}

              type="text"
              name="titleAr"
            />
               <DLabel
              labelText="Video"
              value={video}
              onChange={(e)=> {setVideo(e.target.value)}}
              type="text"
              name="video"
            />
            <DLabel
              labelText="Date"
              value={date}
              onChange={(e)=> {setDate(e.target.value)}}
   
              type="date"
              name="date"
            />
                <Select Data={videoCategorys} labelText={("Select Category")} value={categoryId} setValue={setCategoryId}  />
  
  <label  className="pb-2 text-tcolor-5  text-md font-kufi">
              {t("Upload Image")}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              name=""
              id="upload"
              className="hidden"
              onChange={inmageHandle}
            />
  
            {imageShow ? (
              <div className="h-[180px] relative">
                <label htmlFor="0">
                  <img
                    className="w-full h-full rounded-lg border"
                    src={imageShow.url} // الوصول إلى url مباشرةً
                    alt=""
                    style={{
                      borderColor: currentColor,
                    }}
                  />
                </label>
                <input
                  onChange={(e) => changeImage(e.target.files[0])}
                  type="file"
                  id="0"
                  className="hidden"
                />
                <span
                  onClick={removeImage}
                  className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
                  style={{ backgroundColor: currentColor }}
                >
                  <IoCloseSharp />
                </span>
              </div>
            ) : (
              <label
                className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
                htmlFor="image"
                style={{
                  borderColor: currentColor,
                }}
              >
                <span>
                  <BsImages size={40} color={currentColor} />
                </span>
                <span
                  className=" text font-kufi text-md"
                  style={{
                    color: currentColor,
                  }}
                >
                  {t("Select Image")}
                </span>
              </label>
            )}
  
            <input
              onChange={inmageHandle}
              className="hidden"
              type="file"
              id="image"
            />
            <br />
          </div>
          <DSpinButton isLoading={isSpinner}>{t("Edit")}</DSpinButton>
        </form>
      </div>
    )
  }</>

  );
}

export default EditVideo;